module.exports = __webpack_public_path__ + "static/media/weedshower.591c347a.jpg";